<template>
  <article v-if="tile" class="head-to-head" :class="`head-to-head--style-${tile.style}`">
    <header class="head-to-head__header">
      <img
        v-if="tile.image && !failedImages.market"
        :src="tile.image"
        alt=""
        @error="failedImages.market = true"
      />
      <span v-else class="head-to-head__market-initials" aria-hidden="true">{{
        initials(tile.title)
      }}</span>
      <div>
        <router-link class="head-to-head__title" :to="marketLink">{{ tile.title }}</router-link>
        <p v-for="side in incumbents" :key="side.id" class="head-to-head__incumbent">
          {{ side.name }}{{ side.partyLabel ? ` (${side.partyLabel})` : '' }} · incumbent
        </p>
        <p v-if="tile.date" class="head-to-head__date">{{ tile.date }}</p>
      </div>
    </header>
    <div class="head-to-head__contenders">
      <button
        v-for="(side, index) in sides"
        :key="side.id"
        class="head-to-head__contender"
        :class="{ 'head-to-head__contender--right': index === 1 }"
        :style="sideStyle(side, index)"
        :disabled="isTradeDisabled(side)"
        :aria-label="
          opensOrderSlip
            ? `Buy Yes: ${side.name}${side.buyPrice !== null ? ` at ${side.buyPrice} ${tile.odds ? 'percent' : 'cents'}` : ''}`
            : `View contract: ${side.name}`
        "
        @click="trade(side, $event)"
        @mouseenter="activeSide = index"
        @mouseleave="activeSide = null"
        @focus="activeSide = index"
        @blur="activeSide = null"
      >
        <span class="head-to-head__portrait">
          <img
            v-if="side.image && !failedImages[side.id]"
            :src="side.image"
            alt=""
            @error="failedImages[side.id] = true"
          />
          <span v-else class="head-to-head__initials">{{ initials(side.name) }}</span>
          <span
            v-if="tile.style === HeadToHeadCardStyle.SplitBarChunky"
            class="head-to-head__trade-label"
            >{{ opensOrderSlip ? 'Click to trade' : 'View contract' }}</span
          >
        </span>
        <span class="head-to-head__identity"
          ><span class="head-to-head__name"
            >{{ side.name }}{{ side.partyLabel ? ` (${side.partyLabel})` : '' }}</span
          ><span
            v-if="tile.style !== HeadToHeadCardStyle.SplitBarChunky"
            class="head-to-head__value"
            >{{ side.display }}</span
          ></span
        >
      </button>
    </div>
    <div class="head-to-head__bar" aria-hidden="true">
      <span
        :style="{ width: `${tile.shares[0]}%`, background: tile.left.color, color: tile.left.ink }"
        :class="{ 'is-active': activeSide === 0 }"
        ><span v-if="tile.style === HeadToHeadCardStyle.SplitBarChunky && tile.shares[0] >= 14">{{
          tile.left.display
        }}</span></span
      >
      <span
        v-if="tile.style === HeadToHeadCardStyle.SplitBarChunky"
        class="head-to-head__other"
        :style="{ width: `${tile.shares[1]}%` }"
      ></span>
      <span
        :style="{
          width: `${tile.shares[tile.shares.length - 1]}%`,
          background: tile.right.color,
          color: tile.right.ink,
        }"
        :class="{ 'is-active': activeSide === 1 }"
        ><span v-if="tile.style === HeadToHeadCardStyle.SplitBarChunky && tile.shares[2] >= 14">{{
          tile.right.display
        }}</span></span
      >
    </div>
    <div v-if="tile.style === HeadToHeadCardStyle.SplitImage" class="head-to-head__prices">
      <button
        v-for="side in sides"
        :key="side.id"
        :style="sideStyle(side, 0)"
        :disabled="isTradeDisabled(side)"
        :aria-label="
          opensOrderSlip
            ? `Buy Yes: ${side.name}${side.buyPrice !== null ? ` at ${side.buyPrice} ${tile.odds ? 'percent' : 'cents'}` : ''}`
            : `View contract: ${side.name}`
        "
        @click="trade(side, $event)"
      >
        <strong>Buy {{ side.buyName }}{{ side.buyDisplay ? ` ${side.buyDisplay}` : '' }}</strong>
      </button>
    </div>
    <div v-if="tile.style === HeadToHeadCardStyle.SplitBarChunky" class="head-to-head__legend">
      <span
        ><i :style="{ background: tile.left.color }"></i>{{ tile.left.name }}
        {{ tile.left.display }}</span
      >
      <span v-if="tile.other === null || tile.other > 0"
        ><i class="head-to-head__other"></i>Other
        {{ tile.other === null ? '—' : `${tile.other}${tile.currentPriceSymbol}` }}</span
      >
      <span
        ><i :style="{ background: tile.right.color }"></i>{{ tile.right.name }}
        {{ tile.right.display }}</span
      >
    </div>
  </article>
  <div v-else class="head-to-head head-to-head--unavailable" role="status">
    <p>Head to Head is unavailable for this market (misconfigured contracts).</p>
  </div>
</template>
<script src="./h2h-market-tile.js"></script>
<style src="./h2h-market-tile.scss" lang="scss"></style>
